// extracted by mini-css-extract-plugin
module.exports = {"heading":"App_heading__2nYdz","form_div":"App_form_div__2Vl00","form_input":"App_form_input__19Jpx","verdict":"App_verdict__2rLeI"};